import React from 'react';
import { Component } from 'react';

import { shuffle } from '../js/util';
import API from '../js/api';

import Loading from './Loading';
import Instructions from './Instructions';
import Start from './Start';
import Review from './Review';
import Score from './Score';
import PlayScreen from './PlayScreen';
import GameSounds from './GameSounds';

import styles from '../styles/App.css';

import conf from '../js/conf.json';

export default class App extends Component {

  constructor () {
    super();

    this.state = {
      page: "loading",
      loadingProgress: 0,
      playState: null,
      isCountdown: true
    };

    this.characters = shuffle(['frog','pig','cow','bear','monkey','octopus']);
    this.racers = shuffle(['teal','red','green','blue']);

    this.api = new API();

    this.api.loadQuestions().then(() => {
      // Load first question
      const question = this.api.nextQuestion();

      if(question) {
        this.setState({question});
      } else {
        // Something went wrong, there aren't any questions
        this.setState({page: "score"});
      }

    });

    this._windowResize = () => {
      console.log("resize");
      this.forceUpdate();
    };

  }

  componentDidMount() {
    window.addEventListener("resize", this._windowResize);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this._windowResize);
  }

  onResourcesLoaded () {
    this.setState({page: "start"});
  }

  onResourcesProgress (progress) {
    this.setState({loadingProgress: progress});
  }

  answerClick (index) {
    const correct = this.api.answerQuestion(index);

    if(correct) {
      this.setState({animation: "player-correct"});
    } else {
      this.setState({animation: "enemy-correct"});
    }
    setTimeout(()=>this.setState({animation:null}), 800);

    if(this.api.hasMoreQuestions()) {

      // There are still more questions so start displaying next question.

      shuffle(this.characters);
      this.setState({question: this.api.nextQuestion()});

    } else {

      // No more questions so send result to server and start finish animations.

      this.api.saveResult();

      this.setState({playState: "finishing"});

      setTimeout(() => {
        this.setState({playState: "finished"});
      }, 1000);

      setTimeout(() => {
        this.setState({page: "review", playState: "stopped"});
      }, 5000)
    }
  }

  startGame (racer) {
    this.setState({racer, page: "playing", playState: "countdown"});
    shuffle(this.racers);

    setTimeout(() => {
      this.setState({playState: "playing"});
    }, 3000);
  }

  reviewNext () {
    this.setState({page: "score"});
  }

  scoreNext () {
    this.api.reset();

    const question = this.api.nextQuestion();
    this.setState({page: "start", question});
  }

  exitGame () {
    console.log("Thank you for playing!");

    // TODO: perform close game action
  }

  showInstructions () {
    this.setState({page: "instructions"});
  }

  showStart () {
    this.setState({page: "start"});
  }

  render () {
    const { page, loadingProgress, playState, racer, question, animation } = this.state;
    let questionText;
    let answers;

    if(question) {
      questionText = question.text;
      const answerTexts = question.answers;

      answers = answerTexts.map((a,i) => {
        return {
          text: a,
          character: this.characters[i]
        }
      });
    }

    let overlay;
    switch (page) {
      case "loading": overlay = <Loading progress={loadingProgress} />; break;
      case "instructions": overlay = <Instructions onBackBtn={()=>this.showStart()} text={conf.instructionText} />; break;
      case "start": overlay = <Start onStartBtn={(racer)=>this.startGame(racer)} onInstructionsBtn={()=>this.showInstructions()} />; break;
      case "review": overlay = <Review questions={this.api.getQuestions()} onNextBtn={()=>this.reviewNext()} />; break;
      case "score": overlay = <Score api={this.api} onNextBtn={()=>this.scoreNext()} onExitBtn={()=>this.exitGame()} />; break;
    }

    const screenStyle = {
      display: page == "playing" ? "block" : "none"
    };

    const enemyRacer = this.racers[0] == racer ? this.racers[1] : this.racers[0];

    return (
      <div className={styles.overlay}>
        { overlay }
        <PlayScreen
          style={screenStyle}
          playState={playState}
          onResourcesLoaded={()=>this.onResourcesLoaded()}
          onResourcesProgress={()=>this.onResourcesProgress()}
          playerRacer={racer}
          enemyRacer={enemyRacer}
          question={questionText}
          answers={answers}
          onAnswerClick={(i)=>{this.answerClick(i)}}
          api={this.api}
          score={this.api.score}
          animation={animation} 
          questionNumber={this.api.questionNumber}
          questionCount={this.api.questions.length}
        />
        <GameSounds page={page} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/App.js